import { Main, Acl, Entry } from 'Pages'
import { MainSiderWrapper } from 'Components'

{ Login, SignUp } = Entry

export default [{
  component: () -> MainSiderWrapper(Login)
  path: '/login'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(SignUp)
  path: '/signup'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(Acl)
  path: '/acl'
  isPublic: false
}, {
  component: () -> MainSiderWrapper(Main)
  path: '/:spaceId?'
  isPublic: true
}]
